import apiService from '../api/apiService';
import { Sale } from '../types/orderTypes';
import { PaginatedResponse } from '../types/salesTypes';
import { AxiosResponse } from 'axios';

const SalesController = {
  getSales : (page: number = 0, size: number = 10): Promise<AxiosResponse<PaginatedResponse<Sale>>> => apiService.get<PaginatedResponse<Sale>>('/products/sales',{ page, size } ), 
  getSale : (saleId: string): Promise<AxiosResponse<Sale>> => apiService.get<Sale>(`/products/sales/${saleId}`),
  // Backend uses @ModelAttribute + has a MultipartFile media field, so requests
  // must be multipart/form-data. Accept FormData here; the form constructs it.
  createSale : (data: FormData | Sale): Promise<AxiosResponse<Sale>> => apiService.post<Sale>('/products/sales' ,  data),
  updateSale: (saleId: string, data: Partial<Sale>): Promise<AxiosResponse<Sale>> => apiService.patch<Sale>(`/products/sales/${saleId}`, data),
  addSaleMedia: (saleId: string, file: File): Promise<AxiosResponse<any>> => {
    const formData = new FormData();
    formData.append('media', file);
    return apiService.patch<any>(`/products/sales/${saleId}/add-media`, formData);
  },
  deleteSale: (saleId: string): Promise<AxiosResponse<any>> => apiService.delete<any>(`/products/sales/${saleId}`),
  deleteSaleMedia: (saleId: string, mediaKey: string): Promise<AxiosResponse<any>> => apiService.delete<any>(`/products/sales/${saleId}/media/${mediaKey}`),
  updateSaleStatus: (saleId: string,data: { status: string }): Promise<AxiosResponse<Sale>> => apiService.patch<Sale>(`/products/sales/${saleId}/update-status`, data),
};

export default SalesController;